import React from 'react';

// Square avatar with serif initials.  Mandate detail uses the large (64px)
// variant; cards/rows use the `small` (36px) variant.

interface Props {
  name?: string;
  small?: boolean;
}

const initialsFrom = (name?: string): string => {
  if (!name) return '?';
  return name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w.charAt(0).toUpperCase())
    .join('');
};

const ClientMark = ({ name, small }: Props) => (
  <div className={`client-mark${small ? ' small' : ''}`}>{initialsFrom(name)}</div>
);

export default ClientMark;
